var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWekZfvTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-347.000000, -790.000000) translate(337.000000, 778.000000) translate(10.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 7,
    r: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 22,
    x: 1,
    y: 1,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.164 18.293L8.505 8.175 15.442 18.293 20.414 13.949 26.164 18.752"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWekZfvTo);
export default __webpack_public_path__ + "static/media/WekZfvTO.2b1cbe23f893ecac7fe385cab03840da.svg";
export { ForwardRef as ReactComponent };